import React from "react";
import hero from "../../assets/images/menu-banner.png";
export default function Hero() {
  return (
      <div className="hero">
        {/* <div className="hero-left">
          <h1>
            OUR EXCLUSIVE <span>Menu</span>
          </h1>
          <p>From hearty breakfasts to classic comfort meals — find your favorites here.</p>
        </div>

        <div className="hero-right">
          <img src={hero} alt="Hero Food" />
        </div> */}
        <img src={hero} className="menu-hero" alt="Hero Food" />
      </div>
  );
}
